import React from 'react';
import '../App.css';
import dice from './menuImages/dice.png';

const Games = ()=>{
    return(
      <div className="screen" style={{backgroundImage:'url('+dice+')'}}>
      </div>
    );
}
export default Games;